export interface BingTranslatorSettings {
    url: string;
    secret: string
};


interface BackTranslation {
    displayText: string,
    normalizedText: string
}

interface Translation {
    backTranslations: BackTranslation[],
    displayTarget: string,
    normalizedTarget: string,
    posTag: string
}

export interface TranslationResult {
    translations: Translation[],
    displaySource: string,
    normalizedSource: string
}



export class BingTranslatorClient {
    static create(config: BingTranslatorSettings) {
        return new BingTranslatorClient(config);
    }

    private readonly url: string;
    private readonly secret: string;

    private constructor({url, secret} : BingTranslatorSettings) {
        this.url = url;
        this.secret = secret;
    }

    async getTranslations(word : string) : Promise<TranslationResult> {
        let result = await fetch(`${this.url}/dictionary/lookup?api-version=3.0&from=nl&to=en`, {
            method: "POST",
            headers: {
                "Ocp-Apim-Subscription-Key": this.secret,
                "Content-Type": "application/json"
            },
            body: JSON.stringify([
                {'Text': word}
            ])
        }).then(r => r.json());

        return result[0]
    }
}